import { put, select, takeLatest } from 'redux-saga/effects'
import { FluidsConstants } from '../store/fluids.constants'
import { saveFluids } from '../store/fluids.actions'
import ValidationService from '../../validation/services/validation.services'
import { clearValidationErrorsByPathList } from '../../../utilities/runRulesValidation.util'
import { getRulesSelector } from '../../rules/selectors'
import { setRulesErrors } from '../../rules/store/rules.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IRulesState } from '../../rules/store/rules.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* clearFluidsFields() {
  const fluidConstants = [
    FluidsConstants.SET_BEFORE_INTAKE_CRYS,
    FluidsConstants.SET_BEFORE_INTAKE_COLL,
    FluidsConstants.SET_BEFORE_INTAKE_OTHER,
    FluidsConstants.SET_BEFORE_INTAKE_FEEDINGS,
    FluidsConstants.SET_BEFORE_OUTPUT_EBL,
    FluidsConstants.SET_BEFORE_OUTPUT_UO,
    FluidsConstants.SET_BEFORE_OUTPUT_OTHER,
    FluidsConstants.SET_BEFORE_OUTPUT_BM,
    FluidsConstants.SET_DURING_INTAKE_CRYS,
    FluidsConstants.SET_DURING_INTAKE_COLL,
    FluidsConstants.SET_DURING_INTAKE_OTHER,
    FluidsConstants.SET_DURING_INTAKE_FEEDINGS,
    FluidsConstants.SET_DURING_OUTPUT_EBL,
    FluidsConstants.SET_DURING_OUTPUT_UO,
    FluidsConstants.SET_DURING_OUTPUT_OTHER,
    FluidsConstants.SET_DURING_OUTPUT_BM,
    FluidsConstants.SET_CUSTOM_FLUID_VALUE,
  ]

  try {
    fluidConstants.forEach((constant) => {
      ValidationService.clearValidation(constant)
    })

    const rules: IRulesState = yield select(getRulesSelector)
    const updatedErrors = clearValidationErrorsByPathList(rules.errors, ['fluids'])
    yield put(setRulesErrors(updatedErrors))
    yield put(saveFluids())
  } catch (e) {
    yield put(throwPcrException(`clearFluidsFields() error: ${e}`))
  }
}

export function* clearFluidsFieldsSaga() {
  yield takeLatest(FluidsConstants.CLEAR_FLUIDS_FIELDS, performWithMutexHOG, clearFluidsFields)
}
